import React from "react";
import { FiArrowRight } from "react-icons/fi";
import { GiHoneycomb, GiHoneyJar, GiPresent } from "react-icons/gi";
import {
  QuickLink,
  QuickLinkArrow,
  QuickLinkIcon,
  QuickLinksContainer,
  QuickLinksHeader,
  QuickLinksRoot,
  QuickLinkTitle,
} from "./HomeQuickLinksElements";
import { Reveal } from "../../general/Reveal";
import { Eyebrow, Heading } from "../../general/Typography";
import { useLanguage } from "../../../contexts/LanguageContext";

const QUICK_LINKS = [
  { category: "mez", titleKey: "CATEGORIES.MEZ", Icon: GiHoneyJar },
  {
    category: "meheszeti-termekek",
    titleKey: "CATEGORIES.MEHESZETI_TERMEKEK",
    Icon: GiHoneycomb,
  },
  {
    category: "mezes-csomagok",
    titleKey: "CATEGORIES.MEZES_CSOMAGOK",
    Icon: GiPresent,
  },
];

const HomeQuickLinks = () => {
  const { t } = useLanguage();

  return (
    <QuickLinksRoot>
      <QuickLinksHeader>
        <Reveal>
          <Eyebrow>{t("HOME.QUICK_LINKS_EYEBROW")}</Eyebrow>
        </Reveal>
        <Reveal delay={0.1}>
          <Heading>{t("HOME.QUICK_LINKS_TITLE")}</Heading>
        </Reveal>
      </QuickLinksHeader>
      <QuickLinksContainer>
        {QUICK_LINKS.map(({ category, titleKey, Icon }, index) => (
          <Reveal key={category} delay={0.15 + index * 0.12}>
            <QuickLink to={`/products?category=${category}`}>
              <QuickLinkIcon>
                <Icon />
              </QuickLinkIcon>
              <QuickLinkTitle>{t(titleKey)}</QuickLinkTitle>
              <QuickLinkArrow>
                <FiArrowRight />
              </QuickLinkArrow>
            </QuickLink>
          </Reveal>
        ))}
      </QuickLinksContainer>
    </QuickLinksRoot>
  );
};

export default HomeQuickLinks;
